import { render, staticRenderFns } from "./CompanyStatisticsRow.vue?vue&type=template&id=bc7902d4&"
import script from "./CompanyStatisticsRow.vue?vue&type=script&lang=js&"
export * from "./CompanyStatisticsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc7902d4')) {
      api.createRecord('bc7902d4', component.options)
    } else {
      api.reload('bc7902d4', component.options)
    }
    module.hot.accept("./CompanyStatisticsRow.vue?vue&type=template&id=bc7902d4&", function () {
      api.rerender('bc7902d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company-settings/CompanyStatisticsRow.vue"
export default component.exports